module.exports = __webpack_public_path__ + "img/service_icon.76066c51.png";